import { getCookie, setCookie, removeCookie } from "@Src/utils/cookie.utils";
import { Types } from "@Src/redux/actionTypes";
import { LANGUAGE_COOKIE } from "@Src/constants";

export const LANGUAGE_SELECTION = "LANGUAGE_SELECTION";
export const UPDATE_LANGUAGE = "UPDATE_LANGUAGE";

// keep this for a few weeks in order to pick it up from the old cookie name
const oldLanguage = getCookie("language");
const value = getCookie(LANGUAGE_COOKIE);
export const initialState = {
  language: oldLanguage || value || "",
};

function languageReducer(state = initialState, action) {
  const { type, language } = action;
  switch (type) {
    case Types.UPDATE_LANGUAGE:
      if (oldLanguage) {
        removeCookie("language");
      }
      setCookie(LANGUAGE_COOKIE, language, 2 * 365);
      return {
        ...state,
        language,
      };
    default:
      return state;
  }
}

export const getLanguageSelector = (state) => state?.language || "";

export default languageReducer;
